/** BIG TASK SERVICES * BIG TASK SERVICES * BIG TASK SERVICES */


// CREATE new BigTask
async function createBigTask(uId, token, today, bigTask) {
  // returns true if successful, or throws error

  // build the data
  const newBigTask = { ...bigTask };
  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify({'bigtask': newBigTask}),
  });
  const responseData = await response.json();
  console.log('*** createBigTask() > responseData ****', responseData);
  // "err handling"
  if (!response.ok) {
    throw new Error(response.message || 'Failed to create new Big Task');
  } else {
    return responseData;
  }
}


// READ One BigTask
async function getBigTaskFromDbase(uId, token, today) {
  // returns a bigTask obj || false
  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}/bigtask.json?auth=${token}`);

  // error handling
  if (!response.ok) {
    throw new Error(response.message || 'Failed to get today\'s Big Task');
  }
  const data = await response.json();

  // send back the BigTask
  return data ? data : false;
}


// UPDATE one Big Task
async function updateBigTask(uId, token, today, bigTask) {
  // returns true if update is successful, or throws error

  // prepare data
  const updatedBigTask = { ...bigTask };

  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify({'bigtask': updatedBigTask}),
  });
  // get the response
  const responseData = await response.json();
  if (response.ok) {
    return responseData;
  } else {
    throw new Error(response.message || 'Failed to update Big Task');
  }

}


// DELETE one Big Task
async function deleteBigTask(uId, token, today) {
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/days/${uId}/${today}/bigtask.json?auth=${token}`, {
    method: 'DELETE',
  });
  const responseData = await response.json();

  if (!response.ok) {
    throw new Error(response.message || 'Failed to delete Big Task');
  } else {
    // console.log('*** deleteBigTask() > responseData ****', responseData);
    return responseData;
  }
}



// EXPORTS
export { createBigTask, getBigTaskFromDbase, updateBigTask, deleteBigTask };
